// Actions/studentDetailsActions.js

import api from "lib/api/api";
import {
  FETCH_STUDENT_DETAILS_FAILURE,
  FETCH_STUDENT_DETAILS_REQUEST,
  FETCH_STUDENT_DETAILS_SUCCESS,
} from "../Actions/types";

export const fetchStudentDetails = (studentId) => async (dispatch) => {
  dispatch({ type: FETCH_STUDENT_DETAILS_REQUEST });
  try {
    const response = await api.get(
      `/enrollment/teacher/${studentId}/enrolled-courses-students`
    );
    dispatch({
      type: FETCH_STUDENT_DETAILS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_STUDENT_DETAILS_FAILURE,
      payload: error.message,
    });
  }
};
